<template>
  <div class="mv-bg-main">
    <el-card class="mr">
      <ve-ring :data-empty="loginEmpty" :settings="chartSettings" :data="loginData" :title="loginTitle" ></ve-ring>
    </el-card>
    <el-card class="mr">
      <ve-ring :data-empty="incomeEmpty" :settings="chartSettings" :data="incomeData" :title="incomeTitle"></ve-ring>
    </el-card>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.mr {
  margin: 10px;
}
</style>
<script>
import 'v-charts/lib/style.css'
export default {
  name: 'eventAnalysis',
  data () {
    this.chartSettings = {
      radius: [50, 100],
      legendLimit: 0,
      label: {
        formatter: '{b} :{d}%'
      }
    }
    return {
      loginEmpty: false,
      incomeEmpty: false,
      loginTitle: {
        text: '登录TOP10',
        itemGap: 20,
        top: '',
        left: 'left',
        textStyle: {
          color: '#FF6694',
          fontSize: 20
        }
      },
      incomeTitle: {
        text: '客户充值TOP10',
        itemGap: 20,
        top: '',
        left: 'left',
        textStyle: {
          color: '#FF6694',
          fontSize: 20
        }
      },
      loginData: {
        columns: ['name', 'value'],
        rows: [
        ]
      },
      incomeData: {
        columns: ['name', 'value'],
        rows: [
        ]
      }
    }
  },
  created () {
    let _this = this
    this.$axios({
      url: _this.$API.analysis.queryLoginRank,
      method: 'get'
    }).then((response) => {
      if (response.data && response.data.resData && response.data.resData.loginInfoList.length) {
        _this.loginEmpty = false
        for (let v of response.data.resData.loginInfoList) {
          let op = {}
          op.name = v.name
          op.value = v.count
          _this.loginData.rows.push(op)
        }
      } else {
        _this.loginEmpty = true
      }
    }).catch((err) => {
      console.log(err)
    })
    this.$axios({
      url: _this.$API.analysis.queryRechargeRank,
      method: 'post',
      data: {}
    }).then((response) => {
      if (response.data && response.data.resData && response.data.resData.rechargeList.length) {
        _this.incomeEmpty = false
        for (let v of response.data.resData.rechargeList) {
          let op = {}
          op.name = v.custName
          op.value = v.totalRecharge
          _this.incomeData.rows.push(op)
        }
      } else {
        _this.incomeEmpty = true
      }
    }).catch((err) => {
      console.log(err)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/analysis/eventAnalysis.vue